import { LegalLayout } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/company";

const sections = [
  {
    heading: "Éditeur du site",
    body: [
      `Le présent site est édité par ${COMPANY.name}, entreprise individuelle exploitée par ${COMPANY.owner}.`,
      `Adresse : ${COMPANY.address}`,
      `SIRET : ${COMPANY.siret}`,
      `Téléphone : ${COMPANY.phone}`,
      `Email : ${COMPANY.email}`,
    ],
  },
  {
    heading: "Directeur de la publication",
    body: [`${COMPANY.owner}, en qualité de gérant de ${COMPANY.name}.`],
  },
  {
    heading: "Hébergement",
    body: [
      "Le site est hébergé par : Namecheap, Inc.",
      "4600 East Washington Street, Suite 305, Phoenix, AZ 85034, États-Unis",
      "Site web : www.namecheap.com",
    ],
  },
  {
    heading: "Propriété intellectuelle",
    body: [
      "L'ensemble du contenu du site (textes, visuels, logo, code) est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de MadCode, sauf mention contraire. Toute reproduction ou représentation, totale ou partielle, sans autorisation écrite préalable est interdite.",
    ],
  },
  {
    heading: "Données personnelles",
    body: [
      "Les données transmises via le formulaire de contact sont utilisées uniquement pour répondre aux demandes et sont conservées 3 ans au maximum. Pour en savoir plus sur le traitement de vos données et exercer vos droits (accès, rectification, effacement), consultez nos CGU ou écrivez à " + COMPANY.email + ".",
    ],
  },
  {
    heading: "Contact",
    body: [
      `Pour toute question relative au site ou à ses mentions légales : ${COMPANY.email} — ${COMPANY.phone}.`,
    ],
  },
];

export default function MentionsLegales() {
  return (
    <LegalLayout
      testId="mentions-page"
      overline="Légal"
      title="Mentions légales"
      updated="Juin 2026"
      sections={sections}
    />
  );
}
